export default {
    locations(state){
        let locations=[];

        state.locations.forEach(location => { locations.push({ id:location.woeId, text:location.locationName }) });

        return locations;
    },    
    trendTweets(state) {
        return state.trendTweets;
    },
    connectedTweetAccounts(state) {
        return state.connectedTweetAccounts;
    },
    authorizeUrl(state) {
        return state.authorizeUrl;
    }
}